import { TimetableReports } from '../../../components/EvaluateTimetable/TimetableReports';

export const EvaluateByTeachers = () => {
  return <TimetableReports topic='teachers' />;
};
